export const CancelContent = {
  linkText: `Quit`,
  modalHeader: `Are you sure you want to quit?`,
  yes: `Yes`,
  no: `No`,
};
